import React from 'react'

class BlogNonFeatured extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="BlogNonFeatured card">
        bla...
      </div>
    )
  }

}

export default BlogNonFeatured;



// WEBPACK FOOTER //
// ./src/components/blog/BlogNonFeatured.jsx